const ValidationRoot = { ActiveRecord: { Validations: {} }};

class Validator {
  static resolveClass(className) {
    let validationNode = ValidationRoot;

    className.split("::").forEach((classNamePart) => {
      if(validationNode) validationNode = validationNode[classNamePart];
    });

    return validationNode;
  }

  constructor({ attributeName, options }) {
    this.attributeName = attributeName;
    this.options = options;
  }
}

class PresenceValidator extends Validator {
  errorMessages(instance) {
    let messages = [];
    const value = instance[this.attributeName];

    if(!value) {
      messages = messages.concat(this.options?.message || "Must be present");
    }

    return messages;
  }
}

class NumericalityValidator extends Validator {
  errorMessages(instance) {
    let messages = [];
    const value = instance[this.attributeName];

    Object.entries(this.options).forEach(([optionName, optionValue]) => {
      if(optionName == 'greaterThan') {
        if(value <= optionValue) messages.push(`Must be greater than ${optionValue}`);
      } else if(optionName == 'greaterThanOrEqualTo') {
        if(value < optionValue) messages.push(`Must be greater than or equal to ${optionValue}`);
      } else if(optionName == 'lessThan') {
        if(value >= optionValue) messages.push(`Must be less than ${optionValue}`);
      } else if(optionName == 'lessThanOrEqualTo') {
        if(value > optionValue) messages.push(`Must be less than or equal to ${optionValue}`);
      } else {
        console.warn(`ValidationRoot.ActiveRecord.Validations.NumericalityValidator Option not Implemented: ${optionName}`);
      }
    });

    return messages;
  }
}

class FormatValidator extends Validator {
  errorMessages(instance) {
    let messages = [];
    const value = instance[this.attributeName];

    if(typeof value == 'string' && !value.match(this.options.with)) {
      messages = messages.concat(this.options?.message || "Format invalid");
    }

    return messages;
  }
}

ValidationRoot.ActiveRecord.Validations.PresenceValidator = PresenceValidator;
ValidationRoot.ActiveRecord.Validations.NumericalityValidator = NumericalityValidator;
ValidationRoot.ActiveRecord.Validations.FormatValidator = FormatValidator;

const instanceMethods = {
  validateAttribute(attributeName) {
    let messages = []

    const validators = this.constructor.validatorsByAttribute[attributeName];

    if(validators) {
      validators.forEach((validator) => {
        messages = messages.concat(validator.errorMessages(this));
      });
    }

    return messages;
  },

  validate(attributeOrAttributeList) {
    const errorsByAttributeName = {};

    if(!attributeOrAttributeList) {
      attributeOrAttributeList = Object.keys(this.constructor.validatorsByAttribute);
    } else if(!Array.isArray(attributeOrAttributeList)) {
      attributeOrAttributeList = [attributeOrAttributeList];
    }

    attributeOrAttributeList.forEach((attributeName) => {
      errorsByAttributeName[attributeName] = (errorsByAttributeName[attributeName] || [])
        .concat(this.validateAttribute(attributeName));
    });

    return errorsByAttributeName;
  }
}

export default {
  defineValidators() {
    this.validatorsByAttribute = {};

    this.schema.validators.forEach((validator) => {
      validator.attributes.forEach((attributeName) => {
        if(!this.validatorsByAttribute[attributeName]) this.validatorsByAttribute[attributeName] = [];

        let ValidatorClass = Validator.resolveClass(validator.className);

        if(ValidatorClass) {
          let validatorInstance = new ValidatorClass({ attributeName, ...validator });
          this.validatorsByAttribute[attributeName].push(validatorInstance);
        } else {
          console.warn(`Undefined Validator Class for ${validator.className}`);
        }
      });
    });

    Object.assign(this.prototype, instanceMethods);
  }
}
